import {
  post,
} from '.';

// eslint-disable-next-line import/prefer-default-export
export const createComment = comment => post('/comments', { comment });
